module.exports = __webpack_public_path__ + "img/singletrack-promo-middle.c450f7c1.png";